import remark from "remark"
import remarkHTML from "remark-html"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import React from "react"

export const toHtml = markdown => {
  return remark()
    .use(remarkHTML)
    .processSync(markdown)
    .toString()
}

export const useTranslatedData = data => {
  const { i18n } = useTranslation()
  if (!data) return null
  return translate(data, i18n.language)
}

const translate = (data, lang) => {
  const translated = {}
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      const retKey = key.includes("_") ? key.split("_")[0] : key

      /**
       * if 'key' is a property with language, we need to extract just the value of
       * the property that correspond with the current language
       * */
      if (key.includes("_") && `${retKey}_${lang}` !== key) {
        continue
      }

      if (Array.isArray(data[key])) {
        translated[retKey] = data[key].map(item => translate(item, lang))
      } else if (data[key] instanceof Object) {
        translated[retKey] = translate(data[key], lang)
      } else {
        translated[retKey] = data[key]
      }
    }
  }

  return translated
}
export const baseFontSize = 16,
  baseFontSizeSmall = 14

export const createConvert = baseFontSize => metric => pixels =>
  `${pixels / baseFontSize}${metric}`

export const toRem = createConvert(baseFontSize)("rem")

export const NoMargin = ({ children }) => {
  const Marginated = styled[children.type]`
    margin: 0 !important;
  `
  return <Marginated {...children.props}>{children.props.children}</Marginated>
}

export const Override = ({ children, style }) => {
  const Overrided = styled[children.type]`
    ${style}
  `
  return <Overrided {...children.props}>{children.props.children}</Overrided>
}
